/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, ControlLabel, FormGroup, Row } from 'react-bootstrap';
import { actions, Control, Errors, Form } from 'react-redux-form';
import { updateOutletRest } from '../../../actions/outlet';
import RangeSlider from '../../common/form/range-slider';
import Select from '../../common/form/dropdown';
import ArrowButton from '../../common/button-arrow';
import DeliveryAddressPartial from '../../delivery-address/delivery-address-partial';
import t from '../../../data/translations';

const OUTLET_MODEL = 'deep.admin_outlet_view';

class OutletRewardDetails extends Component {
  mapDenominations = (denominations) => {
    if (denominations) {
      return denominations.map(denomination => ({
        value: denomination.id,
        label: denomination.variant,
      }));
    }
    return [];
  };

  handleTypeChange = (event) => {
    this.setState({
      voucher_denominations: event ? this.mapDenominations(this.props.nominations[event.value]) : [],
      selected_denomination: null,
      selected_type: event,
    });

    this.props.dispatch(actions.change('deep.admin_outlet_view.voucher_denomination_id', ''));
  };

  handleSubmit = (values) => {
    this.props.dispatch(actions.submitFields('deep.admin_outlet_view', updateOutletRest(this.props.id, values, this.props.dispatch)));
  };

  constructor(props) {
    super(props);
    this.state = {
      slider: 100,
      autoRedeem: this.props.reward['auto-redeem'],
      voucher_denominations: []
    };
  }

  componentWillMount() {
    const {
      dispatch, reward, voucher, nominations
    } = this.props;
    dispatch(actions.load('deep.admin_outlet_view.reward_markup', 100 - reward['reward-markup']));

    let selectedVoucher = {attributes: {}};
    let selectedDenomination = {};
    let availableDenominations = [];

    if (reward['voucher-type']) {
      selectedVoucher = voucher.voucher_types.find(voucherType => (voucherType.id === reward['voucher-type'].id.toString()))
        || selectedVoucher;
      if (selectedVoucher.id) {
        const nomination = nominations[selectedVoucher.id];
        availableDenominations = this.mapDenominations(nomination);
        if (reward['voucher-denomination']) {
          selectedDenomination = nomination.find(denomination => (
            denomination.id === reward['voucher-denomination'].id
          )) || selectedDenomination;
        }
      }
    }

    this.setState({
      selected_type: {
        value: selectedVoucher.id,
        label: selectedVoucher.attributes.name
      },
      selected_denomination: {
        value: selectedDenomination.id,
        label: selectedDenomination.variant
      },
      voucher_denominations: availableDenominations
    });
  }

  render() {
    const {
      selected_type, voucher_denominations, selected_denomination
    } = this.state;
    const {reward, voucher, delivery} = this.props;

    const vouchers_types = voucher.voucher_types.map(voucher_type => (
      {
        value: voucher_type.id,
        label: voucher_type.attributes.name
      }
    ));

    return (
      <div className="fluid">
        <Form model={OUTLET_MODEL} onSubmit={this.handleSubmit}>
          <Row>
            <Col md={12}>
              <RangeSlider
                labels={{
                  start: 'Personal Rewards',
                  end: t('staffRewards')
                }}
                max={100}
                min={0}
                model="deep.admin_outlet_view.reward_markup"
                value={reward['reward-markup']}
              />
              <Errors className="errors" model="deep.admin_outlet_view.reward_markup"/>
            </Col>
          </Row>
          <div>
            <Row>
              <Col md={3}>
                Voucher type
              </Col>
              <Col md={9}>
                <Select
                  data={vouchers_types}
                  model="deep.admin_outlet_view.voucher_type_id"
                  onChange={this.handleTypeChange}
                  value={selected_type}
                />
                <Errors
                  className="errors"
                  model=".voucher_type_id"
                  show={{touched: true}}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <ControlLabel>
                    <Control.checkbox model=".auto_redeem"/>
                    {' '}
                    { t('staffRewards.autoRedeem') }
                  </ControlLabel>
                  <Errors
                    className="errors"
                    model=".auto_redeem"
                    show={{touched: true}}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                Voucher denominations
              </Col>
              <Col md={9}>
                <Select
                  data={voucher_denominations}
                  model="deep.admin_outlet_view.voucher_denomination_id"
                  value={selected_denomination}
                />

                <Errors
                  className="errors"
                  model=".voucher_denomination_id"
                  show={{touched: true}}
                />
              </Col>
            </Row>
          </div>

          <DeliveryAddressPartial addressDetails={delivery} model={OUTLET_MODEL}/>

          <Row className="mg-top-20">
            <Col className="text-right" md={12}>
              <ArrowButton arrow={false}>
                Update
              </ArrowButton>
            </Col>
          </Row>

        </Form>
      </div>
    );
  }
}

export default connect()(OutletRewardDetails);



// WEBPACK FOOTER //
// ./src/components/admin/outlet-view/outlet-reward-details.jsx